import { useEffect } from 'react'
import { attFormats } from 'consts'

interface useInitFormatsProps {
  formats: Array<string>
  setFormats: Function
}

const useInitFormats = (props: useInitFormatsProps) => {
  useEffect(() => {
    const attFormatsSelected: Array<{ id: string; name: string }> = []

    props.formats.forEach((fmtSelected) => {
      const attFmtObj: { id: string; name: string } | undefined = attFormats.find(
        (f) => f.id === fmtSelected,
      )
      if (attFmtObj !== undefined) {
        attFormatsSelected.push(attFmtObj)
      }
    })

    attFormatsSelected.sort((a, b) =>
      a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' }),
    )

    props.setFormats(attFormatsSelected)
  }, [])
}

export default useInitFormats
